import { hasValidSubscription } from '@/helpers/validateSubscription';
import { EediPlusContext } from '@/providers/EediPlus/EediPlusProvider';
import { useContext } from 'react';
import { useSelector } from 'react-redux';

export const useEediPlusAction = action => {
  const subscription = useSelector(({ user }) => user.subscription);
  const { launchModal } = useContext(EediPlusContext);

  return () => {
    if (hasValidSubscription(subscription)) {
      return action();
    }

    launchModal();
  };
};
